import { style, media } from 'typestyle'
import { important } from 'csx'
export const mr0smi = style(media({ maxWidth: 576 }, { marginRight: important('0px') }))
